import React from "react";
import { Code, Server, Terminal, ExternalLink, Cpu } from "lucide-react";
import { Helmet } from "react-helmet-async";

export function ApiInfo() {
  return (
    <div className="max-w-4xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
      <Helmet>
        <title>API & Metadata – 247 DevTools Hub</title>
        <meta name="description" content="Explore programmatic metadata and llms.txt endpoints for 247 DevTools Hub. Build integrations or prompt AI crawlers." />
      </Helmet>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-10 space-y-8">
        
        {/* Header */}
        <div className="border-b border-slate-100 pb-6">
          <div className="flex items-center gap-3 mb-2">
            <Cpu className="w-8 h-8 text-blue-600" />
            <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight">API & Programmatic Access</h1>
          </div>
          <p className="text-slate-500 text-sm">
            Access tool definitions, configurations, and LLM-friendly crawler files.
          </p>
        </div>

        {/* Info Grid */}
        <div className="space-y-6 text-slate-600 text-sm leading-relaxed">
          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2">
              <Terminal className="w-5 h-5 text-blue-600" />
              1. LLM Integration (llms.txt)
            </h2>
            <p>
              We provide a standard machine-readable <code>llms.txt</code> file in the website root directory to assist AI search engines, Large Language Models, and crawler bots with cataloging our suite of developer tools.
            </p>
            <div className="bg-slate-900 rounded-xl p-4 text-xs font-mono text-slate-200 overflow-x-auto">
              <a href="/llms.txt" className="text-blue-400 hover:underline flex items-center gap-1.5" target="_blank" rel="noopener">
                View llms.txt Endpoint <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </div>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2">
              <Server className="w-5 h-5 text-blue-600" />
              2. Browser-Only Architecture
            </h2>
            <p>
              Because 247 DevTools Hub is 100% serverless and client-side, <strong>there is no dynamic back-end server API to charge you subscription fees</strong>. This guarantees your data is processed instantly with zero network roundtrip latency. You are free to audit our script assets directly in your browser's Developer Tools network console.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2">
              <Code className="w-5 h-5 text-blue-600" />
              3. Tool Registry Definition
            </h2>
            <p>
              All tools are categorized and structured. Here is a sample metadata representation of the tools registry used inside our routing matrix:
            </p>
            <pre className="bg-slate-50 p-4 rounded-xl border text-xs font-mono text-slate-800 overflow-x-auto">
{`{
  "id": "csv-editor",
  "name": "CSV Editor",
  "description": "Edit CSV data in a table.",
  "category": "JSON / Data",
  "path": "/csv-editor"
}`}
            </pre>
          </section>
        </div>

      </div>
    </div>
  );
}
